import './GameView.css'
import React from "react";
import { EVENTS } from "../src/core/EVENTS";
import * as PIXI from "../src/core/PIXI";
import { Howl } from "howler";

import gsap, { Power1, Power3 } from "gsap"

import PlaneAndGraph from "./game/PlaneAndGraph";
import Background from "./game/Background";
import { Comm } from './core/comm/Comm';
import { Controller } from './core/Controller';
import ColorOverlayFilter from './ColorOverlayFilter';
import Common from './Common';

import PromoUfc from './gfx/game_view/promo_ufc.svg';
import PromoOfficial from './gfx/game_view/promo_official.svg';

const PROMOTION = true;

export default class GameView extends React.Component<GameView.Props, GameView.State>
{


    loading: number;

    colorIndex: number;
    colorFilter: ColorOverlayFilter;
    colors: Array<[red: number, green: number, blue: number]> = [
        [0.204, 0.706, 1.000],
        [0.569, 0.243, 0.973],
        [0.753, 0.090, 0.706]
    ];

    // Refs
    canvasRef: React.RefObject<HTMLCanvasElement>;
    ref: React.RefObject<HTMLDivElement>;
    textMpRef: React.RefObject<HTMLParagraphElement>;
    divProgressRef: React.RefObject<HTMLDivElement>;

    // PIXI Classes
    app: PIXI.Application;
    planeAndGraph: PlaneAndGraph;
    background: Background;
    blur: PIXI.Sprite;
    // PIXI refs:
    lastTickTime: number;
    loopAnimationStartedAt: number;
    // linear wave: like sin and cos, but moving linearly
    lin: number = 0;
    linDir: number = 1;     // linear wave direction 1 || -1 
    lin2: number = 0;
    lin2Dir: number = -1;

    // settings
    sound: boolean = false;
    music: boolean = false;
    animations: boolean = false;

    // howler
    howlerSounds: any;
    howlerMusic: any;

    // timers that reset before every round // miliseconds
    roundAnimationMax: number = 5000;

    // language
    langFlew = lang.canvas.flew_away;
    langWait = lang.shared.WAITING_FOR_NEXT_ROUND;

    countdown: any = { value: 0, old: 0 }
    startProgress: any = { value: 0, old: 0 }

    // size refs .. fml
    appWidth: number = 0;
    appHeight: number = 0;

    gameState: Comm.State;

    countdownAnimId: number;

    // hacks
    pendingCallId = 0;
    pendingCalls: Array<gsap.core.Tween> = [];

    tickerInterval: NodeJS.Timeout;
    hiddenAttName: "hidden" | "msHidden" | "webkitHidden";



    constructor(props: GameView.Props)
    {
        super(props);

        this.canvasRef = React.createRef();
        this.ref = React.createRef();
        this.textMpRef = React.createRef();
        this.divProgressRef = React.createRef();

        this.colorIndex = 0;
        this.loading = 3;

        console.log("GameView - constructor...");
    }


    render()
    {
        return (
            <>
                <div
                    id="GameView"
                    ref={this.ref}
                >
                    <canvas ref={this.canvasRef} />

                    <div 
                        className="waiting"
                    >
                        {!PROMOTION && (
                            <>
                                <img 
                                    src={"gfx/game_view/aviator_logo.svg?version="+ version}
                                    className="logo"
                                />

                                <p className="text-waiting">
                                    {this.langWait}
                                </p>
                            </>
                        )}

                        {PROMOTION && (
                            <img
                                className='waiting-promotion-ufc'
                                src={PromoUfc}
                            />
                        )}

                        <div className="loadbar">
                            <div 
                                ref={this.divProgressRef} 
                                className="loadbarProgress"
                            >
                                
                            </div>
                        </div>

                        {PROMOTION && (
                            <img
                                className='waiting-promotion-official'
                                src={PromoOfficial}
                            />
                        )}
                    </div>

                    <div 
                        className="multiplier"
                    >
                        <div
                            className="text-away"
                        >
                            {this.langFlew}
                        </div>
                        <div 
                            className="text-multiplier"
                            ref={this.textMpRef}
                        >
                            1.08x
                        </div>
                    </div>

                </div>
            </>
        );
    }


    startRound()
    {
        this.ref.current.className = "in-progress";
        this.planeAndGraph.startRound();
        this.background.startRound();

        this.colorFilter.setColor(...this.colors[0]);
        gsap.killTweensOf(this.colorFilter.color);
        gsap.killTweensOf(this.blur);
        gsap.to(this.blur, {
            duration: 1,
            alpha: 1
        });
        
        this.playHowl("ping");
    }


    onItemLoad()
    {
        if (--this.loading == 0)
        {
            this.create();
        }
    }


    componentDidMount()
    {
        console.log("GameView - mounted...");

        this.app = window.pixiApp = new PIXI.Application({
            view: this.canvasRef.current,
            _resizeTo: this.canvasRef.current,
            resolution: window.devicePixelRatio || 1,
            resources: [
                "./aviator/gameview1.json",
                "./aviator/sprite_audio.mp3",
                "./aviator/bg_music.mp3"
            ],
            onLoad: this.onItemLoad.bind(this),
            onLoadScope: this,
            antialias: true,
            backgroundColor: 0x000
        });
        this.app.renderer.plugins.accessibility.destroy();
        delete this.app.renderer.plugins.accessibility;

        // @ts-ignore
        window.pixi = this;

        this.blur = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this.blur.alpha = 0;
        this.colorFilter = new ColorOverlayFilter(...this.colors[0]);
        this.blur.filters = [
            this.colorFilter
        ];

        const image_blur = document.createElement("img");
        image_blur.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            canvas.width = image_blur.naturalWidth;
            canvas.height = image_blur.naturalHeight;

            ctx.drawImage(image_blur, 0, 0);

            const texture = PIXI.Texture.from(canvas);

            this.blur.texture = texture;

            this.onItemLoad();
        };
        image_blur.setAttribute("crossorigin", "anonymous");
        image_blur.setAttribute("src", "./aviator/blur.svg?version=" + version);

        const image_godrays = document.createElement("img");
        image_godrays.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            canvas.width = image_godrays.naturalWidth;
            canvas.height = image_godrays.naturalHeight;

            ctx.drawImage(image_godrays, 0, 0);

            const texture = PIXI.Texture.from(canvas);
            PIXI.Resources.textures["godrays"] = texture;

            this.onItemLoad();
        };
        image_godrays.setAttribute("crossorigin", "anonymous");
        image_godrays.setAttribute("src", "./aviator/godrays.svg?version=" + version);

        EVENTS.on(EVENTS.SETTINGS.ANIMATION, this.toggleAnimations, this);
        EVENTS.on(EVENTS.SETTINGS.MUSIC, this.toggleMusic, this);
        EVENTS.on(EVENTS.SETTINGS.SOUND, this.toggleSound, this);
    }


    componentWillUnmount()
    {
        EVENTS.off(EVENTS.PIXI.RESIZE, this.pixiResize, this);

        Comm.off(Comm.RESPONSE.GAME_STATE_STARTING, this.onStarting, this);
        Comm.off(Comm.RESPONSE.GAME_STATE_START, this.onStart, this);
        Comm.off(Comm.RESPONSE.GAME_STATE_IN_PROGRESS, this.onProgress, this);
        Comm.off(Comm.RESPONSE.GAME_STATE_CRASH, this.onCrash, this);

        EVENTS.off(EVENTS.SETTINGS.ANIMATION, this.toggleAnimations, this);
        EVENTS.off(EVENTS.SETTINGS.MUSIC, this.toggleMusic, this);
        EVENTS.off(EVENTS.SETTINGS.SOUND, this.toggleSound, this);

        cancelAnimationFrame(this.countdownAnimId);
    }


    toggleSound(b: boolean = null)
    {
        this.sound = b === null ? !this.sound : b;
        console.log("toggleSound " + this.howlerSounds);
        if (this.howlerSounds === undefined)
        {
            return;
        }
        if (!this.sound)
        {
            this.howlerSounds.stop();
        }
    }

    toggleMusic(b: boolean = null)
    {
        this.music = b === null ? !this.music : b;
        if (this.howlerMusic === undefined)
        {
            return;
        }
        if (this.music)
        {
            if (this.howlerMusic.playing() === false)
            {
                this.howlerMusic.play();
            }
        }
        else
        {
            this.howlerMusic.stop();
        }
    }

    toggleAnimations(b: boolean = null)
    {
        console.log("GameView - toggleAnimations");
        this.animations = b === null ? !this.animations : b;
        if (this.background && this.planeAndGraph)
        {
            this.background.onToggleAnimation(this.animations);
            this.planeAndGraph.onToggleAnimation(this.animations);
        }
    }


    create()
    {
        this.pixi();
        this.howler();

        Comm.on(Comm.RESPONSE.GAME_STATE_STARTING, this.onStarting, this);
        Comm.on(Comm.RESPONSE.GAME_STATE_START, this.onStart, this);
        Comm.on(Comm.RESPONSE.GAME_STATE_IN_PROGRESS, this.onProgress, this);
        Comm.on(Comm.RESPONSE.GAME_STATE_CRASH, this.onCrash, this);
        Comm.on(Comm.RESPONSE.INITIALIZE, this.onInit, this);
        
        EVENTS.on(EVENTS.GAME.BUTTON_CLICK, this.onButtonClick, this);
        EVENTS.on(EVENTS.GAME.PLAYER_CASHOUT, this.onCashout, this);

        this.lastTickTime = performance.now();

        EVENTS.on(EVENTS.PIXI.RESIZE, this.pixiResize, this);
        EVENTS.emit(EVENTS.LOADING.COMPLETE);
    }


    onButtonClick(data: Comm.ResponseTypes.Bet)
    {
        this.playHowl("blip");
    }


    onCashout(data: Comm.ResponseTypes.BetData)
    {
        if (Number(data.win_amount) && Number(data.win_amount) > Number(data.bet_amount))
        {
            this.playHowl("winner");
        }
    }


    onInit(data: Comm.ResponseTypes.Init)
    {
        this.gameState = null;
        this.pixiResize();

        if (Controller.state == "in_progress")
        {
            const index = Common.getMultiplierIndex(Controller.multiplier);
            this.colorFilter.setColor(...this.colors[index]);
            this.blur.alpha = 1;
        }
        else
        {
            this.blur.alpha = 0;
        }
        
        this.planeAndGraph.reset();
        this.background.reset();
    }


    onStarting(data: Comm.ResponseTypes.GameStateStarting)
    {
        this.countdownAnimId = requestAnimationFrame(this.updateCountdown.bind(this));

        this.planeAndGraph.readyPlane();

        this.ref.current.className = "starting";

        this.gameState = data.state;
    }


    updateCountdown()
    {
        this.divProgressRef.current.style.width = (Controller.getCountdownPercentage() * 100) + "%"
        if (Controller.getCountdownPercentage() > 0)
        {
            this.countdownAnimId = requestAnimationFrame(this.updateCountdown.bind(this));
        }
    }


    onStart(data: Comm.ResponseTypes.GameState)
    {
        this.textMpRef.current.innerText = data.plane.distance.toFixed(2) + "x";

        this.ref.current.className = "start";
        
        cancelAnimationFrame(this.countdownAnimId);

        this.planeAndGraph.readyPlane();

        this.gameState = data.state;

    }


    onProgress(data: Comm.ResponseTypes.GameState)
    {
        if (this.gameState !== data.state)
        {
            this.startRound();
        }

        const index = Common.getMultiplierIndex(Controller.multiplier);
        if (index !== this.colorIndex)
        {
            this.colorIndex = index;
            const color = this.colors[index];

            gsap.to(this.colorFilter.color, {
                0: color[0],
                1: color[1],
                2: color[2],
                duration: .5
            });
        }

        this.updateMultiplierText(Controller.multiplier);

        this.gameState = data.state;

    }


    onCrash(data: Comm.ResponseTypes.GameState, init?: boolean)
    {
        this.ref.current.className = "crash";

        gsap.killTweensOf(this.colorFilter.color);
        gsap.killTweensOf(this.blur);
        gsap.to(this.blur, {
            duration: .5,
            alpha: 0
        });

        this.setMultiplierValue(Controller.multiplier);
        
        if (!init)
        {
            this.planeAndGraph.stopRound();
            this.background.stopRound();
            
            this.playHowl("aeroplane");
        }

        this.gameState = data.state;
    }


    updateMultiplierText(newVal: number)
    {
        this.setMultiplierValue(newVal);
    }

    setMultiplierValue(val: number)
    {
        val = Math.max(1, val);
        this.textMpRef.current.innerText = val.toFixed(2) + "x";
    }


    pixi()
    {
        console.log("GameView - create - animations: " + this.animations);

        this.background = new Background(this.app);
        this.app.stage.addChild(this.blur);
        this.planeAndGraph = new PlaneAndGraph(this.app);

        this.background.onToggleAnimation(this.animations);
        this.planeAndGraph.onToggleAnimation(this.animations);

        this.background.reset();
        this.planeAndGraph.cleanUp();
    }



    playHowl(snd: string)
    {
        if (this.howlerSounds)
        {
            if (this.sound)
            {
                this.howlerSounds.play(snd);
            }
        }
    }

    howler()
    {
        this.howlerSounds = new Howl({
            src: [PIXI.Resources.sounds["sprite_audio"]],
            format: ["mp3"],
            volume: 0.5,
            sprite: {
                blip: [0, 522.4489795918367],
                aeroplane: [2e3, 2574.126984126984],
                ping: [6e3, 1515.102040816327],
                winner: [9e3, 4022.857142857143]
            }
        });

        this.howlerMusic = new Howl({
            src: [PIXI.Resources.sounds["bg_music"]],
            format: ["mp3"],
            loop: true,
            volume: 0.1
        });

        if (this.music)
        {
            this.howlerMusic.play();
        }
    }

    pixiResize()
    {
        this.planeAndGraph.onResize();
        this.blur.width = this.app.width;
        this.blur.height = this.app.height;
        this.background.onResize();

        if (this.gameState === "starting" || this.gameState == "start")
        {
            this.planeAndGraph.readyPlane();
        }

    }


    delayedCall(delay: number, callback: Function, params?: any[] | undefined)
    {
        this.pendingCalls.push(gsap.delayedCall(delay, (id: number) =>
        {
            this.pendingCalls.splice(this.pendingCalls.findIndex(t => Number(t.vars.onCompleteParams?.[0]) == id), 1);
            callback.apply(null, params);
        }, [this.pendingCallId++]));
    }


}


export namespace GameView
{
    export interface Props
    {

    }

    export interface State
    {

    }
}